import namespaceHelper from '@/shared/helpers/namespace-helper';
import { namespace, UptakeInsightsMutations } from './types';
import { getDefaultState } from './state';
import Vue from 'vue';

const _mutations = namespaceHelper.removeNamespace(namespace, UptakeInsightsMutations);

export default {
  [_mutations.RESET_STATE](state) {
    Object.assign(state, getDefaultState());
  },
  [_mutations.SET_UPTAKE_INSIGHTS_SEARCH_RESULTS](state, results) {
    state.searchResults = results;
  },
  [_mutations.SET_UNIT_UPTAKE_INSIGHTS](state, results) {
    if (state.selectedInsightId) {
      results.find(i => i.uptakeInsightId === state.selectedInsightId).isSelected = true;
      state.selectedInsightId = null;
    }
    state.unitUptakeInsights = results;
  },
  [_mutations.SET_SELECTED_INSIGHT_ID](state, result) {
    state.selectedInsightId = result.uptakeInsightId;
  },
  [_mutations.SET_SHOW_INSIGHTS](state, showInsights) {
    state.showInsights = showInsights;
  },
  [_mutations.SET_JOB_PROPERTY](state, { uptakeInsightId, property, value }) {
    const job = state.unitUptakeInsights.find(i => i.uptakeInsightId === uptakeInsightId);
    if (job) {
      Vue.set(job, property, value);
    }
  }
};
